import type { StudioApi } from '../../engine/api';
import type { UiStore } from '../uiStore';
import { createItemActions, type ItemActions } from './items';
import { createOutputActions, type OutputActions } from './outputs';

/** Everything menus, hotkeys, context menus and toolbars can trigger, in one place. */
export interface Actions extends ItemActions, OutputActions {}

export function createActions(studio: StudioApi, ui: UiStore): Actions {
  return { ...createItemActions(studio, ui), ...createOutputActions(studio, ui) };
}
